import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { storage, KID_KEY } from "../lib/api";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-canvas">
        <div className="w-12 h-12 rounded-full border-4 border-primary/30 border-t-primary animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function KidProtectedRoute({ children }) {
  const hasKid = !!storage.get(KID_KEY);
  if (!hasKid) return <Navigate to="/kids" replace />;
  return children;
}

export function AdminProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-900">
        <div className="w-12 h-12 rounded-full border-4 border-white/20 border-t-white animate-spin" />
      </div>
    );
  }
  if (!user || user.role !== "admin") return <Navigate to="/login" replace />;
  return children;
}
